import * as _ from 'lodash';
import { IListItem } from '@nkr/models/index';
import { FormEvent } from 'react';
import { Button, FormControl, Well } from 'react-bootstrap'
import { IFilterData } from './filter-data';

interface IProps {
    filters: IFilterData,
    centerList: IListItem[],
    onChange: (filters: IFilterData) => void,
    // onSubmit: () => void
}

const Filters = (props: IProps) => {
    const handleFieldChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        let { name, value } = e.currentTarget;

        let filters = _.cloneDeep(props.filters);

        if (name == 'filterBy') {
            filters.filterBy = parseInt(value);
        }

        if (name == 'centerId') {
            filters.centerId = parseInt(value);
        }

        props.onChange(filters);
    };

    return (
        <Well bsSize='sm'>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <div>Filter By: &nbsp;</div>
                    <div>
                        <FormControl
                            componentClass='select'
                            name='filterBy'
                            value={props.filters.filterBy}
                            onChange={handleFieldChange}
                        >
                            <option value={1}>Donor Center</option>
                            <option value={2}>Recipient Center</option>
                        </FormControl>
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                    <div>Center: &nbsp;</div>
                    <div>
                        <FormControl
                            componentClass='select'
                            name='centerId'
                            value={props.filters.centerId}
                            onChange={handleFieldChange}
                        >
                            <option value={-1}>- All Centers -</option>
                            {props.centerList.map((item, index) =>
                                <option key={'cent-' + index} value={item.id}>{item.description}</option>
                            )}
                        </FormControl>
                    </div>
                </div>

                {/* <Button bsStyle='primary' onClick={props.onSubmit}>Search</Button> */}
            </div>
        </Well>
    );
}

export default Filters;